exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-container {\n  margin-top: 50px;\n  min-height: calc(100vh - 50px); }\n  .home-container .quick-stats {\n    min-height: 5vh;\n    padding: 1em 2.2em 0em; }\n  .home-container .quick-stats .stat {\n      border-radius: 3px;\n      border: 2px solid #595959;\n      color: #595959;\n      padding: .5em 1em;\n      -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 7px 0 rgba(0, 0, 0, 0.19);\n              box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 7px 0 rgba(0, 0, 0, 0.19); }\n  .home-container .quick-stats .stat .close {\n        float: right; }\n  .home-container .quick-stats.hidden {\n      min-height: 0vh;\n      height: 0vh;\n      padding: 0em 0em;\n      visibility: hidden; }\n  .home-container .quick-links {\n    min-height: 5vh;\n    padding: 1em 2em 0em; }\n  .home-container .quick-links .link {\n      padding: 0em .3em; }\n  .home-container .quick-links .link button {\n        width: 100%;\n        margin: 0px 0px 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/home/home.component.scss
// module id = ../../../../../src/app/home/home.component.scss
// module chunks = main